// db.js
import { openDB } from 'idb';

const DB_NAME = 'my-app-db';
const STORE_NAME = 'cache';

export const initDB = async () => {
    return await openDB(DB_NAME, 1, {
        upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME);
        }
        },
    });
};

export const saveData = async (key, data) => {
    const db = await initDB();
    await db.put(STORE_NAME, data, key);
};

export const loadData = async (key) => {
    const db = await initDB();
    return await db.get(STORE_NAME, key);
};

export const clearData = async (key) => {
    const db = await initDB();
    await db.delete(STORE_NAME, key);
};
